import { Heading, Text } from '@elladx/design-system';
import type { ReactNode } from 'react';
interface PageHeaderProps {
    title: string;
    description?: ReactNode;
    /** Right-aligned actions (buttons) shown beside the title. */
    actions?: ReactNode;
}
/** Standard page header: title + one-line description, actions right-aligned. */
function PageHeader({ title, description, actions }: PageHeaderProps) {
    return (<div className="page-header">
      <div>
        <Heading as="h1" variant="display">{title}</Heading>
        {description && <Text>{description}</Text>}
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </div>);
}
export default PageHeader;
